import { supportServiceConnectClient } from "api";

import {
  CreateMarketplaceExtractAttributeGroupRequest,
  CreateMarketplaceExtractAttributeGroupResponse,
  CreateMarketplaceExtractAttributeRequest,
  CreateMarketplaceExtractAttributeResponse,
  CreateMarketplaceGenerateAttributeRequest,
  CreateMarketplaceGenerateAttributeResponse,
  CreateMarketplaceProductAttributeJobRequest,
  CreateMarketplaceProductAttributeJobResponse,
  DeleteMarketplaceExtractAttributeGroupRequest,
  DeleteMarketplaceExtractAttributeGroupResponse,
  DeleteMarketplaceExtractAttributeRequest,
  DeleteMarketplaceExtractAttributeResponse,
  DeleteMarketplaceGenerateAttributeRequest,
  DeleteMarketplaceGenerateAttributeResponse,
  GetMarketplaceExtractAttributeGroupsRequest,
  GetMarketplaceExtractAttributeGroupsResponse,
  GetMarketplaceExtractAttributesRequest,
  GetMarketplaceExtractAttributesResponse,
  GetMarketplaceGenerateAttributesRequest,
  GetMarketplaceGenerateAttributesResponse,
  GetMarketplaceProductAttributeJobResultRequest,
  GetMarketplaceProductAttributeJobResultResponse,
  GetMarketplaceProductAttributeJobsRequest,
  GetMarketplaceProductAttributeJobsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_marketplace_pb";

import { RequestMetadata } from "api/types";

export const getMarketplaceProductAttributeJobs = async (
  headers: Record<RequestMetadata, string>
): Promise<GetMarketplaceProductAttributeJobsResponse> => {
  const req = new GetMarketplaceProductAttributeJobsRequest({});

  return supportServiceConnectClient.getMarketplaceProductAttributeJobs(req, {
    headers,
  });
};

export type CreateMarketplaceProductAttributeJobParams = {
  name: string;
  urlList: string[];
  extractAttributesGroupId: string;
  generateAttributeIds: string[];
};

export const createMarketplaceProductAttributeJob = async (
  {
    name,
    urlList,
    extractAttributesGroupId,
    generateAttributeIds,
  }: CreateMarketplaceProductAttributeJobParams,
  headers: Record<RequestMetadata, string>
): Promise<CreateMarketplaceProductAttributeJobResponse> => {
  const req = new CreateMarketplaceProductAttributeJobRequest({
    name,
    urlList,
    extractAttributesGroupId,
    generateAttributeIds,
  });

  return supportServiceConnectClient.createMarketplaceProductAttributeJob(req, {
    headers,
  });
};

export const getMarketplaceProductAttributeJobResult = async (
  { jobId }: { jobId: string },
  headers: Record<RequestMetadata, string>
): Promise<GetMarketplaceProductAttributeJobResultResponse> => {
  const req = new GetMarketplaceProductAttributeJobResultRequest({
    jobId,
  });

  return supportServiceConnectClient.getMarketplaceProductAttributeJobResult(
    req,
    {
      headers,
    }
  );
};

export const getMarketplaceExtractAttributeGroups = async (
  headers: Record<RequestMetadata, string>
): Promise<GetMarketplaceExtractAttributeGroupsResponse> => {
  const req = new GetMarketplaceExtractAttributeGroupsRequest({});

  return supportServiceConnectClient.getMarketplaceExtractAttributeGroups(req, {
    headers,
  });
};

export type CreateMarketplaceExtractAttributeParams = {
  name: string;
  description: string;
};

export const createMarketplaceExtractAttribute = async (
  { name, description }: CreateMarketplaceExtractAttributeParams,
  headers: Record<RequestMetadata, string>
): Promise<CreateMarketplaceExtractAttributeResponse> => {
  const req = new CreateMarketplaceExtractAttributeRequest({
    name,
    description,
  });

  return supportServiceConnectClient.createMarketplaceExtractAttribute(req, {
    headers,
  });
};

export type CreateMarketplaceExtractAttributeGroupParams = {
  name: string;
  attributes: string[];
};

export const createMarketplaceExtractAttributeGroup = async (
  { name, attributes }: CreateMarketplaceExtractAttributeGroupParams,
  headers: Record<RequestMetadata, string>
): Promise<CreateMarketplaceExtractAttributeGroupResponse> => {
  const req = new CreateMarketplaceExtractAttributeGroupRequest({
    name,
    attributes,
  });

  return supportServiceConnectClient.createMarketplaceExtractAttributeGroup(
    req,
    {
      headers,
    }
  );
};

export const deleteMarketplaceExtractAttributeGroup = async (
  { attributeGroupId }: { attributeGroupId: string },
  headers: Record<RequestMetadata, string>
): Promise<DeleteMarketplaceExtractAttributeGroupResponse> => {
  const req = new DeleteMarketplaceExtractAttributeGroupRequest({
    attributeGroupId,
  });

  return supportServiceConnectClient.deleteMarketplaceExtractAttributeGroup(
    req,
    {
      headers,
    }
  );
};

export const getMarketplaceExtractAttributes = async (
  headers: Record<RequestMetadata, string>
): Promise<GetMarketplaceExtractAttributesResponse> => {
  const req = new GetMarketplaceExtractAttributesRequest({});

  return supportServiceConnectClient.getMarketplaceExtractAttributes(req, {
    headers,
  });
};

export const deleteMarketplaceExtractAttribute = async (
  { attributeId }: { attributeId: string },
  headers: Record<RequestMetadata, string>
): Promise<DeleteMarketplaceExtractAttributeResponse> => {
  const req = new DeleteMarketplaceExtractAttributeRequest({
    attributeId,
  });

  return supportServiceConnectClient.deleteMarketplaceExtractAttribute(req, {
    headers,
  });
};

export const getMarketplaceGenerateAttributes = async (
  headers: Record<RequestMetadata, string>
): Promise<GetMarketplaceGenerateAttributesResponse> => {
  const req = new GetMarketplaceGenerateAttributesRequest({});

  return supportServiceConnectClient.getMarketplaceGenerateAttributes(req, {
    headers,
  });
};

export type CreateMarketplaceGenerateAttributeParams = {
  name: string;
  prompt: string;
  systemPrompt: string;
};

export const createMarketplaceGenerateAttribute = async (
  { name, prompt, systemPrompt }: CreateMarketplaceGenerateAttributeParams,
  headers: Record<RequestMetadata, string>
): Promise<CreateMarketplaceGenerateAttributeResponse> => {
  const req = new CreateMarketplaceGenerateAttributeRequest({
    name,
    prompt,
    systemPrompt,
  });

  return supportServiceConnectClient.createMarketplaceGenerateAttribute(req, {
    headers,
  });
};

export const deleteMarketplaceGenerateAttribute = async (
  { attributeId }: { attributeId: string },
  headers: Record<RequestMetadata, string>
): Promise<DeleteMarketplaceGenerateAttributeResponse> => {
  const req = new DeleteMarketplaceGenerateAttributeRequest({
    attributeId,
  });

  return supportServiceConnectClient.deleteMarketplaceGenerateAttribute(req, {
    headers,
  });
};
